/**
 * 项目相关API接口
 */
import request from './request';
import { USE_MOCK } from './config';
/**
 * 获取项目列表
 */
export async function getProjectList() {
    if (USE_MOCK) {
        return [];
    }
    return request.get('/project/list');
}
/**
 * 获取项目详情
 */
export async function getProjectDetail(id) {
    return request.get(`/project/detail/${id}`);
}
